import { FC } from 'react';

import { PageMetadata } from '@/shared/components/metadata';

const Metadata: FC = () => <PageMetadata description='The requested page could not be found.' segments={['Page Not Found']} />;

export default Metadata;
